module.exports = __webpack_public_path__ + "static/media/agenda.dfcc1708.jpg";